import { render, staticRenderFns } from "./PersistCargaResponsavelView.vue?vue&type=template&id=136ac0d1&"
import script from "./PersistCargaResponsavelView.vue?vue&type=script&lang=ts&"
export * from "./PersistCargaResponsavelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports